import { render, staticRenderFns } from "./MsgSend.vue?vue&type=template&id=7e120246&scoped=true&"
import script from "./MsgSend.vue?vue&type=script&lang=js&"
export * from "./MsgSend.vue?vue&type=script&lang=js&"
import style0 from "./MsgSend.vue?vue&type=style&index=0&id=7e120246&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e120246",
  null
  
)

export default component.exports